export default __webpack_public_path__ + "static/media/GlyGen-one-slide.0edde3f6.pptx";